import React, { useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { FileUploader } from "..";
import { manualUploadAPI } from "../../../api/manualupload/manualUploadAPI";
import { FeedRequestGrid } from "../feed-request-grid/FeedRequestGrid";
import LoadingOverlay from "react-loading-overlay-ts";
import { setFeedData } from "../../../redux/actions";

const FeedContainer = () => {
  const data = useSelector((state) => state.feed);
  const dispatch = useDispatch();
  const [isActive, setActive] = useState(false);
  const [show, setShow] = useState({ status: false, message: "" });

  const onFileAdded = async (binaryStr, fileName) => {
    setActive(true);
    const response = await manualUploadAPI.importFile(
      binaryStr,
      fileName,
      "Feed"
    );
    if (response.status !== 200) {
      setShow({
        status: true,
        message: `C'è un errore o prova a convalidare il file.`,
      });
    } else {
      dispatch(setFeedData(response.data.statusMessage));
      setShow({ status: true, message: `File convalidato con successo.` });
    }
    setActive(false);
  };

  return (
    <>
      <LoadingOverlay active={isActive} spinner text="Loading ...">
        <div className="Feed-page">
          <div className="row">
            <div className="col-xxl-6 Feed-title">Caricamento Massivo</div>
          </div>
          <div className="container border border-light">
            <div className="row justify-content-md-center">
              <div className="col-lg-11">
                <FileUploader type={"Feed"} onFileAdded={onFileAdded} />
              </div>
            </div>
            <div className="row justify-content-md-center">
              <div
                className="col-lg-11"
                style={{ marginTop: "3.2em", marginBottom: "1.6em" }}
              >
                <FeedRequestGrid show={show} setShow={setShow} />
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
};

const mapStateToProps = function(state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export const Feed = connect(mapStateToProps, mapDispatchToProps)(FeedContainer);
